import { useCallback } from 'react';

import { FormOutlined, UploadOutlined, SettingOutlined } from '@ant-design/icons';
import { MenuProps } from 'antd';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import { Outlet, useNavigate } from 'react-router-dom';

import { Sidenav } from '@/components/navigation/Sidenav';
import { IS_PRODUCTION } from '@/config/environment';
import { ROUTES } from '@/config/routes';

const irmLink = ROUTES.getLink(`irm`);
const shareholderBaseLink = ROUTES.getLink(`irm.shareholderBase`);
const configLink = ROUTES.getLink(`irm.config`);
const monitoringLink = ROUTES.getLink(`irm.monitoring`);
const shareholdersLink = ROUTES.getLink(`irm.shareholders`);
const calendarLink = ROUTES.getLink(`calendar`);
const documentUploadLink = ROUTES.getLink(`automation.documents.upload`);
const documentSettingsLink = ROUTES.getLink(`automation.documents.settings`);

const sidenavItems: ItemType[] = [
  {
    label: `Documentos`,
    key: `documents`,
    icon: <FormOutlined />,
    children: [
      {
        label: `Upload`,
        key: documentUploadLink,
        icon: <UploadOutlined />,
      },
      {
        label: `Configurações`,
        key: documentSettingsLink,
        icon: <SettingOutlined />,
      },
    ],
  },
];

const AutomationLayout = () => {
  const navigate = useNavigate();

  const handleSelectItem = useCallback<NonNullable<MenuProps['onClick']>>(
    (e) => {
      if (e.key === irmLink) {
        navigate(irmLink);
      }

      if (e.key === shareholderBaseLink) {
        navigate(shareholderBaseLink);
      }

      if (e.key === configLink) {
        navigate(configLink);
      }

      if (e.key === monitoringLink) {
        navigate(monitoringLink);
      }

      if (e.key === shareholdersLink) {
        navigate(shareholdersLink);
      }

      if (!IS_PRODUCTION && e.key === calendarLink) {
        navigate(calendarLink);
      }

      if (e.key === documentUploadLink) {
        navigate(documentUploadLink);
      }

      if (e.key === documentSettingsLink) {
        navigate(documentSettingsLink);
      }
    },
    [navigate],
  );

  return (
    <>
      <Sidenav items={sidenavItems} onSelectItem={handleSelectItem} />
      <Outlet />
    </>
  );
};

export default AutomationLayout;
